import { createSlice } from "@reduxjs/toolkit";
// import { getUserChatHistory } from "../apis/ChatAIAPI";

const marketingSmsSlice = createSlice({
    name: "marketingSms",
    initialState: {
        marketingTabIndex: 0,
        marketingPage:"SMS"
    },
    reducers: {  
        setMarketingTabIndex: (state, action) => {
            state.marketingTabIndex = action.payload;
        },
        setMarketingPages: (state, action) => {
            state.marketingPage = action.payload;
        }
    },
});

export const {setMarketingTabIndex ,setMarketingPages} = marketingSmsSlice.actions;
export default marketingSmsSlice.reducer;
